import { createFileRoute, Link } from "@tanstack/react-router";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle, Home, Mail, CheckCircle } from "lucide-react";
import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";

export const Route = createFileRoute("/inscription-stripe-unknown")({
	component: InscriptionStripeUnknownPage,
});

function InscriptionStripeUnknownPage() {
	return (
		<div className="min-h-screen flex flex-col bg-white">
							<PublicHeader />
		<div className="flex items-center justify-center py-12 px-4">
			<Card className="w-full max-w-2xl">
				<CardHeader className="text-center">
					<div className="mx-auto mb-4 h-16 w-16 rounded-full bg-amber-100 flex items-center justify-center">
						<AlertTriangle className="h-10 w-10 text-amber-600" />
					</div>
					<CardTitle className="text-3xl text-amber-800">
						Problème lors de la configuration du paiement
					</CardTitle>
					<CardDescription className="text-center text-gray-600 text-lg mt-2">
						Pas de panique ! Votre inscription a bien été enregistrée.
					</CardDescription>
				</CardHeader>
				<CardContent className="space-y-6">
					<Alert className="bg-green-50 border-green-200">
						<CheckCircle className="h-4 w-4 text-green-600" />
						<AlertDescription>
							<p className="font-semibold text-green-900 mb-2">
								Votre inscription est bien prise en compte
							</p>
							<p className="text-sm text-green-800">
								Même si la configuration de votre moyen de paiement n'a pas pu
								être finalisée, votre demande d'inscription a été enregistrée
								avec succès dans notre système.
							</p>
						</AlertDescription>
					</Alert>

					<div className="bg-blue-50 p-4 rounded-lg">
						<h4 className="font-semibold text-blue-900 mb-2">
							Que va-t-il se passer maintenant ?
						</h4>
						<ul className="list-disc list-inside space-y-2 text-sm text-blue-800">
							<li>
								Notre équipe va analyser votre demande d'inscription comme prévu
							</li>
							<li>
								Vous recevrez une réponse par email sous 48 heures maximum
							</li>
							<li>
								<strong>Lors de la première facture</strong>, nous vous
								recontacterons pour finaliser la configuration de votre moyen de
								paiement
							</li>
							<li>
								Vous pourrez à ce moment-là renseigner vos informations de
								paiement en toute sécurité
							</li>
						</ul>
					</div>

					<Alert>
						<Mail className="h-4 w-4" />
						<AlertDescription>
							<p className="font-semibold mb-1">Email de confirmation</p>
							<p className="text-sm">
								Un email de confirmation de votre inscription vous a été envoyé
								à l'adresse que vous avez fournie.
							</p>
						</AlertDescription>
					</Alert>

					<div className="bg-gray-50 p-4 rounded-lg">
						<h4 className="font-semibold text-gray-900 mb-2">
							Questions ou préoccupations ?
						</h4>
						<p className="text-sm text-gray-700 mb-3">
							Si vous souhaitez configurer votre moyen de paiement dès
							maintenant ou si vous avez des questions, n'hésitez pas à nous
							contacter :
						</p>
						<div className="text-sm text-gray-600 space-y-1">
							<p>
								<strong>Email :</strong> contact@revacours.com
							</p>
						</div>
					</div>

					<div className="flex gap-3 pt-4">
						<Button asChild className="flex-1">
							<Link to="/">
								<Home className="mr-2 h-4 w-4" />
								Retour à l'accueil
							</Link>
						</Button>
					</div>
				</CardContent>
			</Card>
		</div>
		<PublicFooter />
		</div>
	);
}
